/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    SubscriptionEventTypeUser,
    SubscriptionEventTypeUserFromJSON,
    SubscriptionEventTypeUserToJSON,
} from './';

/**
 * 
 * @export
 * @interface SubscriptionListenerUser
 */
export interface SubscriptionListenerUser {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionListenerUser
     */
    listenerUrl: string;
    /**
     * 
     * @type {SubscriptionEventTypeUser}
     * @memberof SubscriptionListenerUser
     */
    eventType: SubscriptionEventTypeUser;
}

export function SubscriptionListenerUserFromJSON(json: any): SubscriptionListenerUser {
    return {
        'listenerUrl': json['listenerUrl'],
        
        'eventType': SubscriptionEventTypeUserFromJSON(json['eventType']),
    };
}

export function SubscriptionListenerUserToJSON(value?: SubscriptionListenerUser): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'listenerUrl': value.listenerUrl,
        
        'eventType': SubscriptionEventTypeUserToJSON(value.eventType),
    };
}


